import Api from 'services/Api';

export const getActivity = (appId) => {
  const query = `query Root($app_id: String!) {
    app(id: $app_id) {
      id
      activity {
        active_users {
          ...Group
        }
        installs {
          ...Group
        }
      }
    }
  }

  fragment Group on ApplicationActivityGroup {
    daily {
      ...GroupItem
    }
    monthly {
      ...GroupItem
    }
  }

  fragment GroupItem on ApplicationActivityGroupItem {
    date
    count
  }
  `;
  const variables = {
    app_id: appId,
  };

  return Api.query(query, variables);
};
